import { IdName } from './idName';

export class LocationIdentifier extends IdName { }

export class Location extends IdName {
    address1: string;
    address2: string;
    city: string;
    state: string;
    country: string;
    isActive: boolean;
    tax1: number;
    tax2: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/location.ts